export type LandingVisit = "first" | "returning";

export interface LandingChoice {
  visit: LandingVisit;
  /** Secondary action that opens the requests hub. */
  showHistory: boolean;
  /** Whether the compose action can be used. */
  canCompose: boolean;
}

/**
 * First visit keeps a single start button. A returning requester sees history
 * plus compose; compose stays visible but disabled when the account cannot mint.
 */
export function landingChoice(
  requestCount: number,
  canRequest: boolean
): LandingChoice {
  if (requestCount > 0) {
    return {
      visit: "returning",
      showHistory: true,
      canCompose: canRequest,
    };
  }

  return {
    visit: "first",
    showHistory: false,
    canCompose: canRequest,
  };
}
